// extracted by mini-css-extract-plugin
module.exports = {"rotate":"styles_rotate__scIqV"};